import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(url: string): boolean {
    if (!this.auth.getAccessToken() || !this.auth.getRefreshToken()) {
      if (url) {
        this.auth.lastUrlBeforeLogin = url;
      }
      this.router.navigateByUrl('/');
      return false;
    }
    return true;
  }
}

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(PermissionsService).canActivate(state.url);
};
